import React from "react";
import { FormInput } from "./input";
import { PasswordInput } from "./password-input";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
export const FormRenderer = ({
  formView,
  dataModel,
  errorsModel,
  onChange,
  isTopField = false,
}) => {
  if (!formView || !formView.fields) return null;
  return (
    <>
      {formView.fields
        .filter((f) => f.isTopField === isTopField)
        .map((field) => (
          <React.Fragment key={field.name}>
            <label
              className="font-headings-primary text-[14px] mb-2"
              htmlFor="company-select-input"
            >
              {field.label || field.name}
            </label>
            {field.isPassword ? (
              <React.Fragment>
                <PasswordInput
                  name={field.name}
                  value={dataModel[field.name] || ""}
                  onChange={onChange}
                  error={errorsModel?.[field.name]}
                />
                {/* Password requirements */}
                {(() => {
                  const value = dataModel[field.name] || "";
                  const hasUppercase = /[A-Z]/.test(value);
                  const hasSymbol = /[^A-Za-z0-9]/.test(value);
                  const hasNumber = /[0-9]/.test(value);
                  const hasMinLength = value.length >= 8;
                  const reqs = [
                    {
                      label: "One uppercase",
                      met: hasUppercase,
                    },
                    {
                      label: "One symbol",
                      met: hasSymbol,
                    },
                    {
                      label: "One number",
                      met: hasNumber,
                    },
                    {
                      label: "8 character minimum",
                      met: hasMinLength,
                    },
                  ];
                  return (
                    <div className="flex flex-col mb-4 mt-2 text-white">
                      {reqs.map((r, i) => (
                        <span
                          key={r.label}
                          className="text-sm font-body-primary mt-1 mb-1 flex items-center gap-1"
                        >
                          <CheckCircleIcon
                            className={
                              `${r.met ? "text-success" : "text-[#252632]"} transition-colors duration-300 ease-in-out`}
                          />
                          {r.label}
                        </span>
                      ))}
                    </div>
                  );
                })()}
              </React.Fragment>
            ) : (
              <FormInput
                dataModel={dataModel}
                {...field}
                errorsModel={errorsModel}
                onChange={onChange}
              />
            )}
          </React.Fragment>
        ))}
    </>
  );
};
